module.exports = __webpack_public_path__ + "assets/svg/lesson_modal_ico_4.svg";